import { Model as t } from "../../../../model.js";
class o extends t {
  constructor(a) {
    super(), this.deliveryType = a.deliveryType, this.status = a.status, this.logisticOperator = a.logisticOperator, this.externalId = a.externalId, this.timestamp = a.timestamp, this.additionalData = a.additionalData;
  }
}
export {
  o as TicketHistoryDeliveryModel
};
//# sourceMappingURL=ticketHistoryDelivery.model.js.map
